<template>
    <Select
        :searchable="true"
        :items="events"
        :dropdown-mode="'container'"
        item-key="id"
        v-model="model"
        :placeholder="translate('common.click_to_select_event')"
        @open="emit('open')"
        @close="emit('close')"
        :no-results-text="translate('common.events_not_found')"
    >
        <template v-slot:selected-item="{ selectedItem }">
            <div v-if="selectedItem">
                <span>#{{ selectedItem.id }} {{ selectedItem.fullName }}</span>
                <span class="is-size-7 has-text-grey-light">
                    {{ convertToTimezone(selectedItem.eventDate.startDate, selectedItem.timezone, "yyyy-MM-dd") }}
                </span>
            </div>
        </template>

        <template v-slot:item="{ item }">
            <div class="is-flex is-align-items-center has-pointer-cursor">
                <EventThumbnail :thumbnail-image-url="item.thumbnailImage" :full-name="item.fullName" size="48x48" />

                <div>
                    <div>
                        #{{ item.id }}
                        {{ item.fullName }}
                    </div>
                    <div class="is-size-7 has-text-grey-light">
                        {{ convertToTimezone(item.eventDate.startDate, item.timezone, "yyyy-MM-dd") }}
                    </div>
                </div>
            </div>
        </template>
    </Select>
</template>

<script setup lang="ts">
    import Select from "../Select.vue";
    import { convertToTimezone } from "../dateTimeUtils";
    import { CompactEvent } from "../types";
    import { translate } from "../translations";
    import EventThumbnail from "./EventThumbnail.vue";

    defineProps<{
        events: CompactEvent[];
        modelValue: number | null;
    }>();

    const emit = defineEmits(["open", "close"]);

    const model = defineModel<number | null>();
</script>

<style scoped></style>
